// Laravel Echo configuration for WebSocket (Laravel Reverb)

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import store from '@/store';

window.Pusher = Pusher;

// Get token from localStorage
const getAuthToken = () => localStorage.getItem('token');

// Get company ID from store
const getCompanyId = () => {
  const company = store.getters['auth/company'];
  return company ? company.id : null;
};

// Initialize Echo instance
const useTLS = process.env.VUE_APP_PUSHER_SCHEME === 'https';

const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_KEY || 'mb-key',
  wsHost: process.env.VUE_APP_PUSHER_HOST || 'api.mbtest.aaibuzz.com',
  wsPort: parseInt(process.env.VUE_APP_PUSHER_PORT) || 6004,
  wssPort: parseInt(process.env.VUE_APP_PUSHER_PORT) || 6004,
  forceTLS: useTLS,
  encrypted: useTLS,
  disableStats: true,
  enabledTransports: useTLS ? ['wss'] : ['ws', 'wss'],
  cluster: process.env.VUE_APP_PUSHER_CLUSTER || 'mt1',

  // Auth endpoint for private/presence channels
  authEndpoint: `${process.env.VUE_APP_API_URL || 'http://api.mbtest.aaibuzz.com/api'}/broadcasting/auth`,

  // Custom authorizer to dynamically add headers on each request
  authorizer: (channel, options) => {
    return {
      authorize: (socketId, callback) => {
        const axios = require('axios').default;

        axios.post(options.authEndpoint, {
          socket_id: socketId,
          channel_name: channel.name
        }, {
          headers: {
            'Authorization': `Bearer ${getAuthToken()}`,
            'company-id': getCompanyId()
          }
        })
          .then(response => {
            callback(false, response.data);
          })
          .catch(error => {
            callback(true, error);
          });
      }
    };
  }
});

// Monitor connection state
echo.connector.pusher.connection.bind('state_change', (states) => {
  console.log('[Echo] Connection state changed:', states.previous, '→', states.current);

  if (states.current === 'connected') {
    store.commit('chat/SET_CONNECTED', true);
    console.log('[Echo] WebSocket connected successfully');
  } else if (states.current === 'disconnected' || states.current === 'failed') {
    store.commit('chat/SET_CONNECTED', false);
    console.log('[Echo] WebSocket disconnected');
  } else if (states.current === 'connecting') {
    console.log('[Echo] WebSocket connecting...');
  }
});

// Handle connection errors
echo.connector.pusher.connection.bind('error', (error) => {
  console.error('[Echo] WebSocket error:', error);
  store.commit('chat/SET_ERROR', 'Connection error. Reconnecting...');
});

// Handle subscription errors
echo.connector.pusher.bind('subscription_error', (error) => {
  console.error('[Echo] Subscription error:', error);
  if (error.status === 403) {
    console.error('[Echo] Subscription denied: You do not have permission to access this channel');
    store.commit('chat/SET_ERROR', 'You do not have permission to access this chat');
  }
});

// Log successful subscriptions (development only)
if (process.env.NODE_ENV === 'development') {
  echo.connector.pusher.bind('pusher:subscription_succeeded', (data) => {
    console.log('[Echo] Successfully subscribed to channel:', data);
  });
}

export default echo;
